import { render } from "./FileImageSelector.vue?vue&type=template&id=ddc9935e&scoped=true"
import script from "./FileImageSelector.vue?vue&type=script&lang=js"
export * from "./FileImageSelector.vue?vue&type=script&lang=js"

import "./FileImageSelector.vue?vue&type=style&index=0&id=ddc9935e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddc9935e"]])

export default __exports__